import styled from 'styled-components'

import Box from '../../Box'

const PopInPicture = styled(Box).attrs({ di: 'flex', jc: 'ce', mb: 12 })``

export default PopInPicture
